var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomBarSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80385 2.2334C13.9851 2.2334 17.3862 5.63448 17.3862 9.81576C17.3862 11.7885 16.6292 13.5877 15.3903 14.938L17.828 17.3706C18.0562 17.5988 18.0569 17.9679 17.8288 18.196C17.7151 18.3112 17.5648 18.3681 17.4153 18.3681C17.2666 18.3681 17.1171 18.3112 17.0027 18.1976L14.5355 15.7373C13.2377 16.7767 11.5921 17.3989 9.80385 17.3989C5.62257 17.3989 2.2207 13.997 2.2207 9.81576C2.2207 5.63448 5.62257 2.2334 9.80385 2.2334ZM9.80385 3.40135C6.2665 3.40135 3.38866 6.27842 3.38866 9.81576C3.38866 13.3531 6.2665 16.231 9.80385 16.231C13.3404 16.231 16.2183 13.3531 16.2183 9.81576C16.2183 6.27842 13.3404 3.40135 9.80385 3.40135Z",
    fill: "#222222",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBarSearchWhite);
export default __webpack_public_path__ + "static/media/bottom-bar-search-white.44530d7dea1fa2bc339953922838e002.svg";
export { ForwardRef as ReactComponent };